import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";

function StudentView() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const token = localStorage.getItem("vedhvidhi-admin-token");

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASEURL}/admin/enrollment/${id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setUser(response?.data?.data);
      } catch (error) {
        console.error("Error fetching student:", error);
      }
    };

    if (id) {
      fetchStudent();
    }
  }, [id, token]);

  useEffect(() => {
    const fetchEnrollmentData = async () => {
      if (!user?.userId?._id) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASEURL}/admin/userEnrollment/${user.userId._id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setUserData(response?.data?.data || null);
      } catch (error) {
        console.error("Error fetching enrollment:", error);
      }
    };

    fetchEnrollmentData();
  }, [user, token]);

  const renderKeyValue = (key, value) => (
    <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
      <div style={{ width: "30%", fontWeight: "bold" }}>{key}:</div>
      <div style={{ width: "70%", wordBreak: "break-word" }}>{value || "NA"}</div>
    </div>
  );

  if (!user) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <div className="container">
      <button
        onClick={() => window.history.back()}
        style={{
          marginBottom: "10px",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          fontFamily: "monospace",
          fontSize: "18px",
          color: "#007bff",
          display: "flex",
          alignItems: "center",
          position: "relative",
          padding: "10px 20px",
        }}
      >
        <span style={{ marginRight: "8px" }}>&lt;</span>
        <span style={{ position: "relative", display: "inline-block" }}>
          Back
          <span
            style={{
              content: "''",
              position: "absolute",
              left: 0,
              bottom: -2,
              width: "100%",
              height: "1px",
              borderBottom: "2px solid #007bff",
            }}
          ></span>
        </span>
      </button>

      <div
        style={{
          backgroundColor: "#e9ecef",
          padding: "15px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          marginBottom: "20px",
        }}
      >
        <h3 style={{ marginBottom: "10px", color: "#333", fontWeight: "bold" }}>
          Main Account Holder Name
        </h3>
        <div style={{ fontSize: "16px", color: "#555" }}>{user?.userId?.fullName || "NA"}</div>
      </div>

      <div
        style={{
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          marginBottom: "20px",
        }}
      >
        <h3
          style={{
            marginBottom: "20px",
            color: "#333",
            borderBottom: "2px solid #ddd",
            paddingBottom: "10px",
          }}
        >
          User Information
        </h3>
        {renderKeyValue("Full Name", user?.name)}
        {renderKeyValue("Email", user?.email)}
        {renderKeyValue("Mobile Number", user?.mobile)}
        {renderKeyValue(
          "Date of Birth",
          new Date(user?.dob).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }) || "NA"
        )}
      </div>

      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        {userData?.map((userItem, index) => (
          <div key={index}>
            <h2>Enrollments {index + 1}</h2>
            {userItem?.enrollments?.map((enrollment, i) => (
              <div
                key={i}
                style={{
                  backgroundColor: "#ffffff",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "30px",
                }}
              >
                {renderKeyValue("Order ID", enrollment?.razorPayId || "NA")}
                {renderKeyValue(
                  "Date Of Purchase",
                  enrollment?.createdAt
                    ? new Date(enrollment?.createdAt).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "NA"
                )}
                {renderKeyValue("Batch Name", enrollment?.batchName || "NA")}
                {renderKeyValue("Price", `₹${enrollment?.price || "NA"}`)}
                {renderKeyValue("Payment Status", enrollment?.paymentStatus || "NA")}
                {renderKeyValue("Coupon Code", enrollment?.couponCode || "NA")}
                {renderKeyValue("Time", enrollment?.time || "NA")}
                {renderKeyValue("Course Title", enrollment?.courseId?.title || "NA")}
                {renderKeyValue(
                  "Course Image",
                  <img
                    src={enrollment?.courseId?.courseImg || "/default-image.png"}
                    alt="Course"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/default-image.png";
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default StudentView;
